import { VStack } from '@/package';
import type { Task, User } from '@/type';

import { TaskPeriodLabeledObject } from './TaskPeriodLabeledObject';
import { TaskStatisticSummary } from './TaskStatisticSummary';
import { TaskTotalLabeledObject } from './TaskTotalLabeledObject';
import { TaskWorkFlowPerformance } from './TaskWorkFlowPerformance';

export const TaskStatistics = ({
  taskDetail,
  selectedMember,
}: {
  taskDetail: Task;
  selectedMember?: User['id'];
}) => {
  return (
    <VStack
      gap={1.5}
      className="scrollbar-hide h-full w-[972px] overflow-x-hidden pt-4"
    >
      <TaskStatisticSummary
        taskDetail={taskDetail}
        selectedMember={selectedMember}
      />
      <TaskWorkFlowPerformance
        taskDetail={taskDetail}
        selectedMember={selectedMember}
      />
      <TaskTotalLabeledObject
        taskDetail={taskDetail}
        selectedMember={selectedMember}
      />
      <TaskPeriodLabeledObject
        taskDetail={taskDetail}
        selectedMember={selectedMember}
      />
    </VStack>
  );
};

TaskStatistics.displayName = 'TaskStatistics';
